import styled from 'styled-components';
import MatetialDivider from '@material-ui/core/Divider';

export const Title = styled.h2`
  font-size: 27px;
  text-align: left;
  margin-bottom: 16px;
`;

export const InventoryWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
`;

export const Divider = styled(MatetialDivider)`
  width: 100%;
`;
